import { helpers } from "@shop/frontend/web/js/helpers";
import { EventEmitter } from "@shop/frontend/web/js/components/EventEmitter";
import { arrayHelper } from "@shop/frontend/web/js/helpers/ArrayHelper";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";

export class PriceLegend {
	/**
	 * @param params {Object}
	 * @param params.containerClassName {String}
	 */
	constructor({ containerClassName } = {}) {
		this.emitter = new EventEmitter();
		this.containerClassName = containerClassName || "js-stadium-zones";

		this.init();
	}

	get $container() {
		return $(`.${this.containerClassName}`);
	}

	init() {
		$(document).on("click", ".js-prices-reset", e => {
			this.reset();
			this.emitter.emit("event:reset");
			return $(e.currentTarget).hide();
		});
	}

	on(action, fn) {
		if (action === "change") {
			this.emitter.subscribe("event:change-input", priceLegends => fn(priceLegends));
		}
		if (action === "reset") {
			this.emitter.subscribe("event:reset", () => fn());
		}
	}

	/**
	 * Создает легенды цен
	 * @param zones {Array} [
	 *   {zone, price, color, free, all}, ...
	 * ]
	 * @param params {Object} { showFreePlaces }
	 */
	render(zones = [], params = {}) {
		this.$container.html("");

		const seatsEndings = [
			translator.t("event", "seat"),
			translator.t("event", "seats"),
			translator.t("event", "seats "),
		];

		if (params.joinEqualPrices) zones = this.joinZonesByEqualPrices(zones);

		zones.sort((a, b) => a.price - b.price);
		$.each(zones, (i, zone) => {
			const freeText = `${translator.t("main", "left")} ${zone.free} ${helpers.wordEnding(
				zone.free,
				seatsEndings
			)}`;

			this.$container.append(
				this.createPriceLegendByZone(zone, {
					usePrimaryColor: !!params.usePrimaryColor,
					freeText: params.showFreePlaces ? freeText : "",
				})
			);
		});

		if (!helpers.isDesktop.matches && params.mobileLastSlot)
			this.$container.append(params.mobileLastSlot);

		this.addListenerToInputs();
		this.addListenerToZones();
	}

	renderHtml(html = "") {
		return this.$container.html(html);
	}

	joinZonesByEqualPrices(zones) {
		let uniqueZones = arrayHelper.uniqueArrayByProperty(zones, "price");
		zones = uniqueZones.map(zone => {
			const equalPrices = zones.filter(z => z.zone !== zone.zone && z.price === zone.price);
			equalPrices.forEach(ep => {
				zone.free += ep.free;
				zone.all += ep.all;
			});
			return zone;
		});
		return zones;
	}

	reset() {
		$(this.$container.find("input[type=checkbox]")).prop("checked", false);
	}

	show() {
		return this.$container.show();
	}

	hide() {
		return this.$container.hide();
	}

	isAdditionalInfo(name) {
		return name === "Ложа 5" || name === "Ложа 14" || name === "VIP 1" || name === 'B1, B2, B3' || name === "D2" || name === "C2, С3" || name === "С2, С3" || name === "VIP 6" || name === "VIP6" || name === "VIP" || name === "VIP 2";
	}

	createPriceLegendByZone(zone, params = {}) {
		const tooltipContent = this.zoneTooltipContent(zone.name);

		if(params.freeText === 'осталось 0 мест') return ''

		return `
			<label
				class="price-legend
				${params.usePrimaryColor ? "price-legend_primary" : ""}"
				style="border-color: ${zone.color}"
			>
				<input
					class="price-legend__input"
					type="checkbox"
					data-price="${zone.price}"
					data-zone-id="${zone.zone}"
				>
				<span class="price-legend__content">
					<span class="price-legend__color" style="background-color: ${zone.color}">
					</span>
					<span class="price-legend__text">
						<span>${zone.price + " ₽" + (zone.name ? ", " + zone.name : "")}</span>
						<br />
						<span style="${!params.freeText ? "display: none" : ""}">
							${params.freeText}
						</span>
					</span>
					<span
						style="${!this.isAdditionalInfo(zone.name) ? "display: none" : ""}"
						class="price-legend__tooltip-icon js-price-legend-tooltip"
						title="${tooltipContent}"
					>
						?
					</span>
				</span>
			</label>`;
	}

	zoneTooltipContent(name) {
		if (name === "Ложа 5") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Доступ на стадион через VIP-вход и лифт</li>
					<li>Организовано питание: холодные и горячие закуски; горячие и прохладительные напитки. Работают официанты.</li>
					<li>Удобные мягкие кресла (свободная рассадка-места на креслах не указаны)</li>
					<li>Лучший вид на стадион</li>
					<li>Личный балкон</li>
					<li>Индивидуальные пледы для гостей</li>
				</ol>
				<p>Возврат билетов в ложу:</p>
				<ul>
					<li>Не менее, чем за 4 дня - возврат стоимости в полном объеме</li>
					<li>За 3-1 день до матча- возврат стоимости, за минусом понесенных Клубом расходов.</li>
					<li>В день матча денежные средства не возвращаются</li>
				</ul>
			`;
		}

		if (name === "Ложа 14") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Доступ на стадион через VIP-вход и лифт</li>
					<li>Организовано питание: холодные и горячие закуски; горячие и прохладительные напитки. Работают официанты.</li>
					<li>Удобные мягкие кресла (свободная рассадка-места на креслах не указаны)</li>
					<li>Лучший вид на стадион</li>
					<li>Личный балкон</li>
					<li>Индивидуальные пледы для гостей</li>
				</ol>
				<p>Возврат билетов в ложу:</p>
				<ul>
					<li>Не менее, чем за 4 дня - возврат стоимости в полном объеме</li>
					<li>За 3-1 день до матча- возврат стоимости, за минусом понесенных Клубом расходов.</li>
					<li>В день матча денежные средства не возвращаются</li>
				</ul>
			`;
		}

		if (name === "VIP 1" || name === "VIP1") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Отдельный вход и лифт</li>
					<li>Приветственный фуршет</li>
					<li>Лучший вид на стадион</li>
					<li>Личный балкон</li>
				</ol>
			`;
		}

		if (name === "B1, B2, B3") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>гостевой сектор, по вопросам приобретения билетов на гостевой сектор (В) необходимо обратиться к сотруднику по работе с болельщиками КЛУБА-ГОСТЯ.</li>
				</ol>
			`;
		}

		if (name === "D2") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>сектор болельщиков команды ФК «Химки». Для организованных групп болельщиков (более 9 человек) предусмотрена скидка 10%. О наличии и стоимости билетов обращаться в отдел по работе с болельщиками по электронной почте fans@fckhimki.ru.</li>
				</ol>
			`;
		}

		if (name === "C2, С3" || name === "С2, С3") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Семейный сектор, здесь можно сформировать детский билет</li>
				</ol>
			`;
		}

		if (name === "VIP 6" || name === "VIP6") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Семейный сектор, здесь можно сформировать детский билет</li>
				</ol>
			`;
		}

		if (name === "VIP") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Центр трибуны А</li>
					<li>Организовано питание: холодные и горячие закуски; горячие и прохладительные напитки.</li>
					<li>Удобные мягкие кресла</li>
				</ol>
			`;
		}

		if (name === "VIP 2") {
			return `
				<p>${name}:</p>
				<span class='price-legend-tooltip__close'></span>
				<ol>
					<li>Организовано питание: холодные закуски; горячие и прохладительные напитки.</li>
					<li>Удобные мягкие кресла</li>
				</ol>
			`;
		}

		return "";
	}

	addListenerToInputs() {
		const $inputs = this.$container.find("input[type=checkbox]");
		/* Обработчик для фильтра по легендам цен */
		$($inputs).on("change", () => {
			const priceLegends = [];
			$.each($($inputs), (index, input) => {
				if ($(input).is(":checked")) {
					priceLegends.push({
						price: Number($(input).attr("data-price")),
						zoneId: Number($(input).attr("data-zone-id")),
					});
				}
			});

			/* Показать кнопку очистки если выбрали несколько цен */
			if (this.$container.find("input:checked").length > 1) {
				$(".js-prices-reset").show();
			} else {
				$(".js-prices-reset").hide();
			}

			this.emitter.emit("event:change-input", priceLegends);
		});
	}

	addListenerToZones() {
		$(document).on("mouseover touchstart", e => {
			$(".js-price-legend-tooltip").tooltip({
				html: true,
				customClass: "price-legend-tooltip",
			});
		});
	}
}
